import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { Action } from '../../actions';
import type { RegulationUiState } from './regulationUi.model';
import { initialRegulationUI } from './regulationUi.model';

export function regulationUiReducer(state: RegulationUiState = {}, action: Action): RegulationUiState {
  switch (action.type) {
    case 'QUOTE_REQUESTED':
    case 'PREVIOUS_QUOTE_LOADED':
      return addOrReplaceKey(state, action.tabId, initialRegulationUI);

    case 'STREAMING_QUOTE_ACKED':
      return addOrReplaceKey(state, action.tabId, initialRegulationUI);

    case 'SET_KID_ACCORDION':
      return patchKey(state, action.tabId, () => ({ kidIsOpen: action.isOpen }));
    case 'SET_MIFID_ACCORDION':
      return patchKey(state, action.tabId, () => ({ mifidIsOpen: action.isOpen }));
    case 'SET_TARGET_ACCORDION':
      return patchKey(state, action.tabId, () => ({ targetIsOpen: action.isOpen }));
    case 'SET_THEORETICAL_VALUE_ACCORDION':
      return patchKey(state, action.tabId, () => ({ theoreticalValueIsOpen: action.isOpen }));
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.tabId);
    default:
      return state;
  }
}
